import React from 'react';
import { clientKpis } from '../../../mocks/client';

/**
 * Portal KPI band (T9.5): hours saved, tasks completed, cost per outcome,
 * open change requests. Read-only metrics — clients never see agency
 * internals (token burn, agent internals) here.
 */
function ClientKPIRow() {
  return (
    <section className="portal-kpis">
      {clientKpis.map((kpi) => (
        <div className="portal-kpi" key={kpi.id}>
          <span>{kpi.label}</span>
          <strong>{kpi.value}</strong>
          <em className={`tone-${kpi.tone}`}>{kpi.delta}</em>
        </div>
      ))}
    </section>
  );
}

export default ClientKPIRow;
